import { AlphabetsDraftApi, useAPIAction } from "melco-shared-logic";
import { ALL_PUBLISHED_STATES } from "../../../helper/publishedState";

export const useDownloadFont = (fontId: string) => {
  return useAPIAction(
    AlphabetsDraftApi,
    async (api) => {
      const data = await api.userAlphabetDownload({
        id: fontId,
        publishState: ALL_PUBLISHED_STATES,
      });

      return {
        successMessages: [],
        data,
      };
    },
    { translationPrefix: "global" }
  );
};
